import { useState } from 'react'

/**
 * Shared loading/refreshing/error state used by most tab screens.
 * Replaces the identical useState triplet duplicated in 5+ screens.
 */
export function useDataLoading(initialLoading = true) {
  const [loading, setLoading] = useState(initialLoading)
  const [refreshing, setRefreshing] = useState(false)
  const [loadError, setLoadError] = useState(false)

  return { loading, refreshing, loadError, setLoading, setRefreshing, setLoadError }
}
